var _path, _g, _path2, _path3, _g2, _g3, _g4, _g5, _g6, _path4, _path5, _path6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _path7, _g22, _path8, _path9, _g23, _g24, _g25, _path10, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYourDetails(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 760,
    height: 428.946,
    viewBox: "0 0 760 428.946",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "your-details",
    transform: "translate(-79.884 2451.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "translate(79.884 -2451.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "translate(0 0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "M364.221-2045.114s-48.838-60.076-24.7-176.112c15.183-72.986,78.963-109.144,164.463-105.691,29.391,1.187,77.21-34.177,145.916-77.617,146.968-92.922,359.557-53.457,308.679,155.551-24.623,101.144,77.444,102.766,26.715,203.869H364.221",
    transform: "translate(-286.23 2451.952)",
    fill: "#e4f0fe"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shadow",
    transform: "translate(0 384.73)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_Path_",
    "data-name": "<Path>",
    cx: 380,
    cy: 22.108,
    rx: 380,
    ry: 22.108,
    transform: "translate(0)",
    fill: "#d3e5f9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Plant",
    transform: "translate(603.735 242.208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M406.37,444.9s8.26-18.022-1.177-35.789-12.174-21.952-6.158-25.592,8.776,14.212,8.776,14.212,5.071-12.282.883-25.135-6.813-33.789-1.1-36.034,1.092,26.117,6.055,35.784c0,0,4.168-10.762,4.853-21.086s-.386-26.809,4.13-31.038,7.41-1.3,2.972,21.481a238.237,238.237,0,0,0-4.406,41.3s9.8-29.887,16.381-30.758,6.571,8.806.939,17.2-16.49,23.434-18.271,31.172c0,0,10.759-22.491,20.438-15.6s-8.425,20.479-16.492,25.387-13.672,35.68-13.672,35.68Z",
    transform: "translate(-375.792 -318.593)",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M406.37,444.9s8.26-18.022-1.177-35.789-12.174-21.952-6.158-25.592,8.776,14.212,8.776,14.212,5.071-12.282.883-25.135-6.813-33.789-1.1-36.034,1.092,26.117,6.055,35.784c0,0,4.168-10.762,4.853-21.086s-.386-26.809,4.13-31.038,7.41-1.3,2.972,21.481a238.237,238.237,0,0,0-4.406,41.3s9.8-29.887,16.381-30.758,6.571,8.806.939,17.2-16.49,23.434-18.271,31.172c0,0,10.759-22.491,20.438-15.6s-8.425,20.479-16.492,25.387-13.672,35.68-13.672,35.68Z",
    transform: "translate(-375.792 -318.593)",
    fill: "#26b462",
    style: {
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M421.127,449.271s-8.043-18.142,1.607-35.768,12.437-21.768,6.465-25.5-8.947,14.082-8.947,14.082-4.925-12.357-.583-25.147,7.218-33.685,1.527-36.015-1.405,26.1-6.483,35.692c0,0-4.038-10.825-4.6-21.158s.706-26.8-3.758-31.1-7.392-1.412-3.229,21.434a238.469,238.469,0,0,1,3.909,41.366s-9.441-30.03-16.009-31-6.676,8.709-1.146,17.186,16.209,23.677,17.9,31.442c0,0-10.489-22.648-20.25-15.9s8.178,20.6,16.186,25.632,13.242,35.88,13.242,35.88Z",
    transform: "translate(-384.03 -315.569)",
    fill: "#2ecc71"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(0 120.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M384.313,388.043h66.447l-5.378,47.549H389.691Z",
    transform: "translate(-384.313 -388.043)",
    fill: "#108387"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g56",
    transform: "translate(280.081 36.267)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path58",
    d: "M1863.944-1887.288H1591.411v-367.773h272.533v367.773",
    transform: "translate(-1591.411 2255.061)",
    fill: "#a8adaf"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g60",
    transform: "translate(296.027 48.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path62",
    d: "M1921.731-1851.164H1678.169v-339.482h243.562v339.482",
    transform: "translate(-1678.169 2190.646)",
    fill: "#2a628f"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "g64",
    transform: "translate(368.102 36.267)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path66",
    d: "M2069.64-2255.066v12.4a12.4,12.4,0,0,0,12.391,12.4h66.557a12.4,12.4,0,0,0,12.394-12.4v-12.4H2069.64",
    transform: "translate(-2069.64 2255.066)",
    fill: "#134270"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "g98",
    transform: "translate(409.534 347.21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path100",
    d: "M2320.742-574.222a6.933,6.933,0,0,0-.276,1.216A9.616,9.616,0,0,0,2320.742-574.222Zm.169,5.956h0Zm-11.423.739a8.865,8.865,0,0,0-.146,4.34C2309.924-565.11,2310.042-566.773,2309.488-567.527Zm6.811,1.491c.183.545.343.651.343.653a10.8,10.8,0,0,0,2.063-3.139c-.549-.022-1.171-.024-1.846-.007A14.084,14.084,0,0,1,2316.3-566.037Zm-6.321,4.566a1.334,1.334,0,0,0,1.021.7c.878.037,1.936-.9,2.893-2.577a15.446,15.446,0,0,0,1.2-2.7,11.4,11.4,0,0,1-.324-2.36c-1.289.1-2.69.278-4.134.54.751,1.464.318,3.939-.653,6.405Zm-10.669-1.9c.608,4.069,2.646,7.058,4.374,7.6a1.976,1.976,0,0,0,2.22-.85,19.936,19.936,0,0,0,2.792-4.777,7.269,7.269,0,0,1-.481-1.513,10.894,10.894,0,0,1,.005-4.445,29.155,29.155,0,0,0-5.471,1.9,18.005,18.005,0,0,0-3.439,2.083Zm12.786,12.589a28.622,28.622,0,0,1-10.6,1.658c-4.514-.376-7.061-2.743-7.16-6.666a10.053,10.053,0,0,1,3.743-8.046c-.025-.211-.045-.425-.062-.639-.166-2.193.3-3.649,1.4-4.332,1.761-1.1,4.382.405,4.494.469l-.588,1c-.588-.341-2.33-1.093-3.3-.486-.833.523-.931,1.957-.861,3.124a24.629,24.629,0,0,1,8.035-3.593,42.9,42.9,0,0,1,7.568-1.294,6.537,6.537,0,0,1,.065-.717c.079-.538.267-1.169.8-1.294a.876.876,0,0,1,.937.489,2.827,2.827,0,0,1,.355,1.41c.842-.02,1.621,0,2.313.047l.02-.044a13.314,13.314,0,0,1,.177-4.043c.3-1.343.777-2.021,1.452-2.088a.891.891,0,0,1,.92.57c.377.911-.332,3.37-1.359,5.732l0,.012c.962.162,1.618.427,1.823.8a.864.864,0,0,1-.236,1.088,1.368,1.368,0,0,1-1.7.364,1.688,1.688,0,0,1-.622-.71,12.145,12.145,0,0,1-2.285,3.4,1.141,1.141,0,0,1-1.351.2,1.2,1.2,0,0,1-.292-.236,16.345,16.345,0,0,1-.884,1.83c-1.213,2.129-2.581,3.227-3.954,3.161a2.25,2.25,0,0,1-1.48-.656,21.379,21.379,0,0,1-2.663,4.376,3.113,3.113,0,0,1-3.464,1.228c-2.251-.7-4.289-3.959-5.049-7.815a8.691,8.691,0,0,0-2.795,6.661c.084,3.348,2.139,5.209,6.1,5.54,10,.83,27.524-8.461,28.852-15.3-1.081,5.558-9.4,11.894-18.349,14.795",
    transform: "translate(-2294.332 575.833)",
    fill: "#f99746"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path102",
    d: "M1838.2-1568.314h39.9v-39.9h-39.9Zm41.975,2.075h-44.051v-44.051h44.051v44.051",
    transform: "translate(-1511.319 1765.982)",
    fill: "#134270"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path106",
    d: "M1838.2-1194.395h39.9v-39.9h-39.9Zm41.975,2.075h-44.051v-44.051h44.051v44.051",
    transform: "translate(-1511.319 1461.232)",
    fill: "#134270"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path110",
    d: "M1838.2-828.209h39.9v-39.9h-39.9Zm41.975,2.075h-44.051v-44.051h44.051v44.051",
    transform: "translate(-1511.319 1162.784)",
    fill: "#134270"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g114",
    transform: "translate(398.874 165.949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path116",
    d: "M2293.87-1550.193h-57.442v-4.3h57.442v4.3",
    transform: "translate(-2236.428 1554.49)",
    fill: "#134270"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "g118",
    transform: "translate(492.33 165.949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path120",
    d: "M2755.416-1550.193h-13.057v-4.3h13.057v4.3",
    transform: "translate(-2742.359 1554.491)",
    fill: "#134270"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "g122",
    transform: "translate(398.874 185.219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path124",
    d: "M2293.87-1445.978h-57.442v-4.3h57.442v4.3",
    transform: "translate(-2236.428 1450.276)",
    fill: "#134270"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "g126",
    transform: "translate(485.916 185.219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path128",
    d: "M2727.045-1445.979h-19.463v-4.3h19.463v4.3",
    transform: "translate(-2707.582 1450.277)",
    fill: "#134270"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "g130",
    transform: "translate(489.386 175.584)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path132",
    d: "M2742.392-1498.086h-16v-4.3h16v4.3",
    transform: "translate(-2726.395 1502.384)",
    fill: "#134270"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "g134",
    transform: "translate(441.387 175.583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path136",
    d: "M2482.824-1498.093h-16v-4.3h16v4.3",
    transform: "translate(-2466.825 1502.391)",
    fill: "#134270"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "g138",
    transform: "translate(398.825 175.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path140",
    d: "M2271.977-1498.078H2236.43v-4.3h35.547v4.3",
    transform: "translate(-2236.43 1502.375)",
    fill: "#134270"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "g142",
    transform: "translate(398.87 232.357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path144",
    d: "M2291.679-1191.058h-55.247v-4.3h55.247v4.3",
    transform: "translate(-2236.432 1195.354)",
    fill: "#134270"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "g146",
    transform: "translate(398.874 251.626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path148",
    d: "M2293.87-1086.847h-57.442v-4.3h57.442v4.3",
    transform: "translate(-2236.428 1091.143)",
    fill: "#134270"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "g150",
    transform: "translate(438.602 241.991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path152",
    d: "M2466.646-1138.957h-14.867v-4.3h14.867v4.3",
    transform: "translate(-2451.779 1143.252)",
    fill: "#134270"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "g154",
    transform: "translate(398.825 241.992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path156",
    d: "M2271.977-1138.95H2236.43v-4.3h35.547v4.3",
    transform: "translate(-2236.43 1143.245)",
    fill: "#134270"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "g158",
    transform: "translate(398.874 300.644)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path160",
    d: "M2293.87-821.753h-57.442v-4.3h57.442v4.3",
    transform: "translate(-2236.428 826.051)",
    fill: "#134270"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "g162",
    transform: "translate(398.874 319.914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path164",
    d: "M2293.87-717.54h-57.442v-4.3h57.442v4.3",
    transform: "translate(-2236.428 721.838)",
    fill: "#134270"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "g166",
    transform: "translate(438.626 310.279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path168",
    d: "M2476.762-769.646h-24.979v-4.3h24.979v4.3",
    transform: "translate(-2451.783 773.944)",
    fill: "#134270"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "g170",
    transform: "translate(398.825 310.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path172",
    d: "M2271.977-769.644H2236.43v-4.3h35.547v4.3",
    transform: "translate(-2236.43 773.942)",
    fill: "#134270"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path174",
    d: "M1866.261-500.148h-30.133v-3.05h30.133v3.05",
    transform: "translate(-1511.344 863.788)",
    fill: "#134270"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "g176",
    transform: "translate(362.044 360.589)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path178",
    d: "M2067.743-500.149h-30.136v-3.05h30.136v3.05",
    transform: "translate(-2037.606 503.2)",
    fill: "#134270"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path180",
    d: "M1877.92-463.4h-41.792v-3.05h41.792v3.05",
    transform: "translate(-1511.323 833.81)",
    fill: "#134270"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path254",
    d: "M833.053-263.506H883.77v-.467H833.053Z",
    transform: "translate(-693.752 668.627)",
    fill: "#eddfd2"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "g304",
    transform: "translate(518.843 260.889)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path306",
    d: "M2891.695-1040.937s2.231,6.882,2.04,8.454-1.593,6.95-2.6,8.326-1.5-5.6-2.288-6.653-.162,2.628-.722,2.967-1.725-2.7-2.225-3.78,1.225-5.037,1.229-7.8,4.563-1.513,4.563-1.513",
    transform: "translate(-2885.812 1041.219)",
    fill: "#ffb27d"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "g308",
    transform: "translate(472.102 195.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path310",
    d: "M2632.417-1383.318a9.767,9.767,0,0,1,14.715-9.194c.139.084.278.17.414.258,10.131,6.52,31.988,36.945,33.491,39.993s5.944,27.3,5.944,27.3-5.488,2.007-8.052-.076c0,0-8.9-23-10.214-24.145s-35.593-20.383-35.884-27.593c-.079-1.906-.232-4.2-.414-6.538",
    transform: "translate(-2632.385 1393.92)",
    fill: "#acc2f7"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "g312",
    transform: "translate(383.518 193.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path314",
    d: "M2196.593-1405.44l2.979,8.558-43.049,14.989-2.982-8.559,43.052-14.988",
    transform: "translate(-2153.541 1405.44)",
    fill: "#407bff"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path316",
    d: "M2107.315-1316.313l11.5.8-2.981-8.559Z",
    transform: "translate(-1732.417 1532.64)",
    fill: "#a8adaf"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "g318",
    transform: "translate(426.655 192.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path320",
    d: "M2393.256-1408.426l.944,2.706a3.191,3.191,0,0,1-1.965,4.063l-1.992.693-2.98-8.558,2.167-.754a3,3,0,0,1,3.825,1.851",
    transform: "translate(-2387.264 1410.444)",
    fill: "#a8adaf"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "g322",
    transform: "translate(518.587 383.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path324",
    d: "M2899.074-377.394s4.084,3.726,3.288,6.376-4.482,4.413-4.982,7.65-2.491,5-4.283,5h-8.549s-1.32-2.279,1.87-2.964,4.388-4.492,4.188-8.021a62.112,62.112,0,0,1,.3-8.24l6.774-1.569,1.394,1.766",
    transform: "translate(-2884.277 379.16)",
    fill: "#263238"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "g326",
    transform: "translate(459.051 391.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path328",
    d: "M2586.251-331.779s.731,8.483-1.061,9.365l-22.949-.047s0-2.647,3.684-3.237,10.166-2.746,11.26-7.552,9.066,1.471,9.066,1.471",
    transform: "translate(-2562.241 335.062)",
    fill: "#263238"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "g330",
    transform: "translate(463.726 272.957)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path332",
    d: "M2587.394-976.884s1.212,14.869,2.634,32.744c1.935,24.28,4.259,54.1,4.49,59.752.4,9.812,1.991,25.506,1.991,25.506s3.783,3.728,11.358,2.156a253.146,253.146,0,0,0,8.674-46.1c.031-.391.059-.781.088-1.171,1.8-24.13,4.584-74.943,4.584-74.943l-33.819,2.06",
    transform: "translate(-2587.394 978.944)",
    fill: "#515b60"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "g334",
    transform: "translate(463.726 272.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path336",
    d: "M2587.394-976.884s1.212,14.869,2.634,32.744l26.514,41.31c.031-.391.059-.781.088-1.171,1.8-24.13,4.584-74.943,4.584-74.943l-33.819,2.06",
    transform: "translate(-2587.394 978.944)",
    fill: "#41494d"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "g338",
    transform: "translate(469.358 267.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path340",
    d: "M2617.409-1001.183s21.817,53.85,36.162,79.157,18.825,32.37,18.825,32.37,8.221-3.237,8.969-5.445c0,0-5.488-48.855-15.093-60.764-5.427-6.732-11.806-26.928-12.1-33.989s-1.94-21.041-1.94-21.041l-34.819,9.711",
    transform: "translate(-2617.409 1010.894)",
    fill: "#515b60"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "g342",
    transform: "translate(464.865 177.353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path344",
    d: "M2616.875-1475.256s-14.616,7.413-23.178,4.94a20.052,20.052,0,0,1,5.67-4.722c-.329-1.7-.587-3.179-.744-4.433a41.227,41.227,0,0,1-.452-4.536l5.605-4.591,5.314-4.393c-.184,12.059,7.785,17.736,7.785,17.736",
    transform: "translate(-2593.696 1492.991)",
    fill: "#ffb27d"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "g346",
    transform: "translate(457.526 190.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path348",
    d: "M2598.746-1341.649a60.167,60.167,0,0,1-18.026,7.766c-7.713,1.83-17.193,1.289-20.362,1.773a1.332,1.332,0,0,1-.928-.233c-.248-.128-1.646-9.536-3.048-21.409-.063-.479-.13-.96-.156-1.444l-.019-.16c-.546-4.642-1.023-9.517-1.437-14.407-.34-3.8-.616-7.562-.81-11.1-.245-4.419-.346-8.48-.245-11.821.045-1.525.137-2.9.27-4.089a29.107,29.107,0,0,1,7.259-15.583l2.584-2.94a14.172,14.172,0,0,0,8.943-2.282c3.156-2.078,6.563-4.313,7.2-3.939,4.837,2.647,8.778,9.505,11.591,18.562a103.5,103.5,0,0,1,3.642,17.4c.257,1.945.473,3.94.635,5.926.035.369.061.734.089,1.1.381,5.43,1,10.519,1.688,15.063.928,6.13,1.977,11.266,2.72,14.881.375,1.84.661,3.264.83,4.283.149.889-1.63,2.164-2.425,2.657",
    transform: "translate(-2553.676 1421.555)",
    fill: "#b3caff"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "g350",
    transform: "translate(469.329 181.739)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path352",
    d: "M2629.106-1468.929s-3.6,6.873-10.66,8.915a40.6,40.6,0,0,1-.448-4.536l5.605-4.591,5.5.213",
    transform: "translate(-2617.998 1469.142)",
    fill: "#ed985f"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "g354",
    transform: "translate(463.77 163.085)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path356",
    d: "M2590.784-1547.087s14.122,2.023,15.275-6.658,3.745-14.267-5.225-15.926-11.163,1.429-12.261,4.235-1.432,17.6,2.211,18.348",
    transform: "translate(-2587.825 1570.137)",
    fill: "#ffb27d"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "g358",
    transform: "translate(459.008 157.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path360",
    d: "M2589.721-1594.472c.126-.149.418-.273,1.076-.322a2.673,2.673,0,0,0-1.236-.321,3.3,3.3,0,0,0-2.25-2.876,1.967,1.967,0,0,1,.984,1.4c-1.856-1.831-5.778-3.114-16.552-2.048-14.2,1.4-9.328,10.416-7.469,11.465s6.439-2.019,9.873-1.814,4.186,5.147,5.363,5.8.7-.536,2.256-1.279,1.761,1.863,1.34,3.568,1.786,3.9,1.786,3.9l2.139-2.4c2.139-2.4,4-12.41,2.969-14.516-.1-.186-.184-.375-.28-.564",
    transform: "translate(-2561.947 1599.025)",
    fill: "#2c3a64"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "g362",
    transform: "translate(457.468 219.532)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path364",
    d: "M2578.488-1264.019s-11.909,9.06-24.532,11.047c-.243-4.419-.343-8.481-.243-11.821l24.775.774",
    transform: "translate(-2553.674 1264.793)",
    fill: "#8fa2cc"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "g366",
    transform: "translate(395.841 200.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path368",
    d: "M2233.6-1358.439c-.189-.2-2.615-8.319-6.815-7.727-2.742.386-7.219,1.972-6.03,5.582.471,1.42,8.817,6.307,8.817,6.307l4.029-4.163",
    transform: "translate(-2220.555 1366.197)",
    fill: "#ffb27d"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "g370",
    transform: "translate(404.522 198.698)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path372",
    d: "M2345.779-1373.56a9.766,9.766,0,0,1-1.022,17.322c-.148.066-.3.128-.448.189-11.181,4.485-48.642,4.693-52,4.153s-25.7-10.954-25.7-10.954,1.538-5.636,4.723-6.523c0,0,23.9,6.059,25.6,5.651s37.226-17.222,43.274-13.286c1.6,1.041,3.555,2.242,5.569,3.448",
    transform: "translate(-2266.614 1377.605)",
    fill: "#b3caff"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3600",
    "data-name": "Path 3600",
    d: "M-374.448-74.569l3.08-6.667h3.334l-4.858,9.432v5.366h-3.1V-71.8l-4.858-9.432h3.344Zm19.626,1.067a8.934,8.934,0,0,1-.772,3.832,5.817,5.817,0,0,1-2.211,2.541,6.115,6.115,0,0,1-3.3.894,6.156,6.156,0,0,1-3.283-.884,5.874,5.874,0,0,1-2.236-2.526,8.677,8.677,0,0,1-.8-3.776v-.732A8.887,8.887,0,0,1-366.637-78a5.865,5.865,0,0,1,2.226-2.551,6.122,6.122,0,0,1,3.288-.889,6.122,6.122,0,0,1,3.288.889A5.865,5.865,0,0,1-355.61-78a8.861,8.861,0,0,1,.788,3.837Zm-3.09-.671a6.227,6.227,0,0,0-.833-3.537,2.716,2.716,0,0,0-2.378-1.209,2.717,2.717,0,0,0-2.368,1.194,6.156,6.156,0,0,0-.844,3.5v.722a6.305,6.305,0,0,0,.833,3.517,2.709,2.709,0,0,0,2.4,1.25,2.684,2.684,0,0,0,2.358-1.2,6.268,6.268,0,0,0,.833-3.511Zm16.505-7.064v9.747a4.99,4.99,0,0,1-1.519,3.842,5.858,5.858,0,0,1-4.152,1.413,5.924,5.924,0,0,1-4.116-1.372,4.905,4.905,0,0,1-1.555-3.771v-9.859h3.049v9.767a2.82,2.82,0,0,0,.7,2.119,2.673,2.673,0,0,0,1.926.666q2.571,0,2.612-2.7v-9.848Zm7.978,9.381h-2.429v5.417h-3.049v-14.8h5.5a6.216,6.216,0,0,1,4.045,1.169,4.034,4.034,0,0,1,1.423,3.3,4.553,4.553,0,0,1-.656,2.526,4.471,4.471,0,0,1-1.987,1.611l3.2,6.047v.142h-3.273Zm-2.429-2.47h2.46a2.518,2.518,0,0,0,1.779-.584,2.089,2.089,0,0,0,.63-1.611,2.236,2.236,0,0,0-.595-1.646,2.471,2.471,0,0,0-1.824-.6h-2.449Zm15.418,7.887v-14.8h4.553a6.914,6.914,0,0,1,3.491.879,6.13,6.13,0,0,1,2.4,2.5,7.711,7.711,0,0,1,.864,3.684v.681a7.733,7.733,0,0,1-.849,3.669,6.078,6.078,0,0,1-2.393,2.49,6.967,6.967,0,0,1-3.486.894Zm3.049-12.328v9.879h1.474a3.311,3.311,0,0,0,2.734-1.169,5.281,5.281,0,0,0,.966-3.344v-.783a5.366,5.366,0,0,0-.935-3.42,3.3,3.3,0,0,0-2.734-1.164Zm19.382,5.915h-5.854v3.964h6.87v2.449h-9.919v-14.8h9.9v2.47h-6.85v3.527h5.854Zm14.147-5.915h-4.533v12.328h-3.049V-78.766h-4.472v-2.47h12.054Zm8.873,9.279h-5.346l-1.016,3.049h-3.242l5.509-14.8h2.825l5.539,14.8h-3.242Zm-4.523-2.47h3.7l-1.86-5.539Zm13.416,5.519h-3.049v-14.8h3.049Zm5.874-2.449h6.474v2.449h-9.523v-14.8h3.049Zm15.9-1.433a1.565,1.565,0,0,0-.61-1.326,8,8,0,0,0-2.2-.976,15.561,15.561,0,0,1-2.51-1.011,4.1,4.1,0,0,1-2.521-3.669,3.573,3.573,0,0,1,.676-2.139,4.409,4.409,0,0,1,1.941-1.469,7.306,7.306,0,0,1,2.841-.528,6.651,6.651,0,0,1,2.825.574,4.5,4.5,0,0,1,1.926,1.621,4.242,4.242,0,0,1,.686,2.378h-3.049a2,2,0,0,0-.64-1.58,2.632,2.632,0,0,0-1.8-.564,2.812,2.812,0,0,0-1.738.473,1.491,1.491,0,0,0-.62,1.245,1.428,1.428,0,0,0,.727,1.209,8.21,8.21,0,0,0,2.139.915,9.244,9.244,0,0,1,3.791,1.941,3.866,3.866,0,0,1,1.189,2.886,3.561,3.561,0,0,1-1.453,3.013,6.362,6.362,0,0,1-3.913,1.093,7.556,7.556,0,0,1-3.11-.625,4.921,4.921,0,0,1-2.139-1.713,4.386,4.386,0,0,1-.737-2.521h3.059q0,2.449,2.927,2.449a2.847,2.847,0,0,0,1.7-.442A1.438,1.438,0,0,0-244.326-70.321Z",
    transform: "translate(728.786 162.041)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYourDetails);
export default __webpack_public_path__ + "static/media/your-details.060d6a8ce46a7bd8796f4979192cd027.svg";
export { ForwardRef as ReactComponent };